import VueRemote from '@common/config/remote'

const wc = new VueRemote()

export default wc
